import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import galaxyRoutes from "./galaxy";
import crmRoutes from "./crm";
import eventsRoutes from "./events";
import directoryRoutes from "./directory";
import emailRoutes from "./email";
import knowledgeBaseRoutes from "./knowledge-base";
import toolsRoutes from "./tools";
import profileRoutes from "./profile";
import quickLinksRoutes from "./quick-links";
import financialRoutes from "./financial";
import portalsRoutes from "./portals";
import miscellaneousRoutes from "./miscellaneous";

const Dashboard = lazy(() => import("@/pages/agent/dashboard/Dashboard"));
const Payments = lazy(() => import("@/pages/agent/payments/Payments"));
const Messages = lazy(() => import("@/pages/agent/messages/Messages"));
const Search = lazy(() => import("@/pages/agent/search/Search"));
const ConferenceMeet = lazy(() => import("@/pages/agent/conference-meet"));
const SupplierSurvey2026Part1 = lazy(() => import("@/pages/agent/supplier-survey-2026-part-1/SupplierSurvey2026Part1"));
const SupplierSurvey2026Part2 = lazy(() => import("@/pages/agent/supplier-survey-2026-part-2/SupplierSurvey2026Part2"));

const agentRoutes: RouteObject[] = [
  { index: true, element: <Dashboard /> },
  {
    path: "crm",
    children: crmRoutes,
  },
  {
    path: "directory",
    children: directoryRoutes,
  },
  {
    path: "profile",
    children: profileRoutes,
  },
  {
    path: "events",
    children: eventsRoutes,
  },
  {
    path: "financial",
    children: financialRoutes,
  },
  {
    path: "knowledge-base",
    children: knowledgeBaseRoutes,
  },
  {
    path: "galaxy",
    children: galaxyRoutes,
  },
  {
    path: "email",
    children: emailRoutes,
  },
  {
    path: "tools",
    children: toolsRoutes,
  },
  {
    path: "quick-links",
    children: quickLinksRoutes,
  },
  {
    path: "portals",
    children: portalsRoutes,
  },
  {
    path: "messages",
    element: <Messages />,
  },
  {
    path: "search",
    element: <Search />,
  },
  {
    path: "payments",
    element: <Payments />,
  },
  {
    path: "conference-meet",
    element: <ConferenceMeet />,
  },
  {
    path: "miscellaneous",
    children: miscellaneousRoutes,
  },
  {
    path: "supplier-survey-2026-part-1",
    element: <SupplierSurvey2026Part1 />,
  },
  {
    path: "supplier-survey-2026-part-2",
    element: <SupplierSurvey2026Part2 />,
  },
];

export default agentRoutes;
